import { F01_MEMOJI_OLDER_IMAGES } from 'data/images/f01/memoji-older'
import type { VariantImagesDefinition } from 'types/images'

import { WALLPIF01_IMAGES } from './default'

export const WALLPIF01_MEMOJI_OLDER_IMAGES = {
  ...F01_MEMOJI_OLDER_IMAGES,
  experience: {
    background: {
      ...WALLPIF01_IMAGES.experience.background,
      srcSet: [
        '/images/wallpif01/memoji-older/experience.webp',
        '/images/wallpif01/memoji-older/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      ...WALLPIF01_IMAGES.experiencePitch.pitch,
      srcSet: [
        '/images/wallpif01/memoji-older/experience_pitch.webp',
        '/images/wallpif01/memoji-older/experience_pitch@2x.webp',
      ],
    },
  },
  energyPitch: {
    ...F01_MEMOJI_OLDER_IMAGES.energyPitch,
    person: {
      ...WALLPIF01_IMAGES.energyPitch.person,
      srcSet: [
        '/images/wallpif01/memoji-older/energy-pitch/person.webp',
        '/images/wallpif01/memoji-older/energy-pitch/person@2x.webp',
      ],
    },
  },
} satisfies VariantImagesDefinition<typeof WALLPIF01_IMAGES>
